import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useProcessesQuery } from '~/queries';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectProcessId: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  ...props
}) => {
  const { t } = useTranslation();

  const { data: processes = [], isLoading: isLoadingProcesses } = useProcessesQuery();

  const processItems = useMemo(
    () =>
      processes.map((process) => ({
        label: process.name,
        value: process.id,
      })),
    [processes],
  );

  return (
    <ApiHelperSelectInput
      label={t('chooseProcess')}
      items={processItems}
      onChange={(value) => setValue('process_id', value)}
      loading={isLoadingProcesses}
      value={value}
      noItemsFound={t('noProcesses')}
      {...props}
    />
  );
};
